import { sanitize } from 'utils/sanitizeString'

interface IParseNoteTags {
  body?: string
}

export const parseNoteTags = (note: IParseNoteTags) => {
  const { body = '' } = note || {}
  const tagRegExp = new RegExp(/\B(@|#)[^(\s|/)]+(\s\(broker\))?/g)

  // matches any link not wrapped with other characters
  const linkRegExp = new RegExp(/(^|\s)(http[s]?:\/\/[^\s]+)/gi)

  /**
   * Match markdown's link pattern for links: [text](#/some/relative/stark/url)
   */
  const linkWithTextRegExp = new RegExp(/\[([^[]+)\]\(([^)]+)\)/g)
  const sanitized = sanitize(body)

  const newNoteBody = sanitized
    .replace(tagRegExp, str => `<strong>${str}</strong>`)
    .replace(
      linkRegExp,
      (full, empty, url) => `${empty}<a target='_blank' href='${url}'>${url}</a>`
    )
    .replace(
      linkWithTextRegExp,
      (match, text, href) => `<a target='_blank' href='${href}'>${text}</a>`
    )
  return newNoteBody
}
